import React from 'react'
import { RouteConfig, RouteGuard, RouteState } from '../typings/router.def'

export const routes: Array<RouteConfig> = [
  {
    name: 'login',
    path: RouteState.Login,
    exact: true,
    component: React.lazy(() => import('../pages/core/Login')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'login',
    path: '/login',
    exact: true,
    component: React.lazy(() => import('../pages/core/Login')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'logout',
    path: RouteState.Logout,
    exact: true,
    component: React.lazy(() => import('../pages/core/Logout')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'password-reset',
    exact: true,
    path: RouteState.PasswordReset,
    component: React.lazy(() => import('../pages/core/PasswordReset')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'new-password',
    exact: true,
    path: RouteState.NewPassword,
    component: React.lazy(() => import('../pages/core/NewPassword')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'sign-up',
    path: RouteState.SignUp,
    exact: true,
    component: React.lazy(() => import('../pages/core/signup/Signup')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'sign-up-success',
    path: RouteState.SignUpSuccess,
    exact: true,
    component: React.lazy(() => import('../pages/core/signup/SignupSuccess')),
    guard: RouteGuard.Anonymous
  },
  {
    name: 'account',
    exact: true,
    path: RouteState.Account,
    component: React.lazy(() => import('../pages/core/account/Account')),
    guard: RouteGuard.Client
  },
  {
    name: 'ads',
    exact: true,
    path: RouteState.Ads,
    component: React.lazy(() => import('../pages/ads/Ads')),
    guard: RouteGuard.Client
  },
  {
    name: 'ad-detail',
    exact: true,
    path: RouteState.EditAd + '/:id',
    component: React.lazy(() => import('../pages/ads/CreateUpdateAd')),
    guard: RouteGuard.Client
  },
  {
    name: 'new-ad',
    exact: true,
    path: RouteState.NewAd,
    component: React.lazy(() => import('../pages/ads/CreateUpdateAd')),
    guard: RouteGuard.Client
  }
]
